module.exports = __webpack_public_path__ + "officialStatic/img/logo14.9706e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo14.png
// module id = PeCU
// module chunks = 0